import { limitChars } from "Utils";
import * as yup from "Utils/yup";
import { AccessTokenFormData, ExpiryRange } from "./types";

export const accessTokenFormSchema: yup.SchemaOf<AccessTokenFormData> = yup
  .object()
  .shape({
    name: limitChars().trim().required("Name is required"),
    expiry: yup
      .mixed()
      .nullable()
      .when("expiryRange", {
        is: (range: string) => range !== "none",
        then: yup.string().required("Please choose a date"),
        otherwise: yup.string().nullable(true),
      }),
    expiryRange: yup
      .mixed<ExpiryRange>()
      .required("Please choose from the available options"),
  });
